import { __decorate, __metadata } from "tslib";
import { IsUndefinable, IsUUIDWithLVS } from '@goparrot/common';
import { HttpStatus } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsNumber, IsOptional, IsString, IsUrl, Length, Max, MaxLength, Min } from 'class-validator';
import { WebRedirectExposeGroup } from '../interface';
export class ReadWebRedirectDto {
}
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebRedirectExposeGroup.MODEL, WebRedirectExposeGroup.READ, WebRedirectExposeGroup.PUT] }),
    IsOptional({ groups: [WebRedirectExposeGroup.PUT] }),
    IsUUIDWithLVS('4', { always: true }),
    __metadata("design:type", String)
], ReadWebRedirectDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebRedirectExposeGroup.MODEL, WebRedirectExposeGroup.READ, WebRedirectExposeGroup.CREATE, WebRedirectExposeGroup.PUT] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    IsUUIDWithLVS('4', { always: true }),
    __metadata("design:type", String)
], ReadWebRedirectDto.prototype, "domainUuid", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebRedirectExposeGroup.MODEL, WebRedirectExposeGroup.READ, WebRedirectExposeGroup.CREATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebRedirectDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebRedirectExposeGroup.MODEL, WebRedirectExposeGroup.READ, WebRedirectExposeGroup.CREATE, WebRedirectExposeGroup.PUT] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(255, { always: true }),
    IsUrl({ require_host: false, require_protocol: false, require_tld: false }, { always: true }),
    __metadata("design:type", String)
], ReadWebRedirectDto.prototype, "fromPath", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebRedirectExposeGroup.MODEL, WebRedirectExposeGroup.READ, WebRedirectExposeGroup.CREATE, WebRedirectExposeGroup.PUT] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    Length(1, 255, { always: true }),
    IsUrl({ require_host: false, require_protocol: false, require_tld: false }, { always: true }),
    __metadata("design:type", String)
], ReadWebRedirectDto.prototype, "toPath", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, default: HttpStatus.FOUND }),
    Expose({ groups: [WebRedirectExposeGroup.MODEL, WebRedirectExposeGroup.READ, WebRedirectExposeGroup.CREATE, WebRedirectExposeGroup.PUT] }),
    IsUndefinable({ always: true }),
    IsNumber(undefined, { always: true }),
    Min(300, { always: true }),
    Max(399, { always: true }),
    __metadata("design:type", Number)
], ReadWebRedirectDto.prototype, "statusCode", void 0);
//# sourceMappingURL=ReadWebRedirectDto.js.map